module.exports = __webpack_public_path__ + "img/pin-live.f7216008.svg";